module.exports = "/static/media/delivery.2a701062.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/delivery.svg
// module id = 1487
// module chunks = 0